<template>
  <v-dialog
    v-model="nuevaSolicitudDialog"
    width="480"
    persistent
  >
    <template #activator="{ on, attrs }">
      <v-btn
        class="secondary"
        rounded
        v-bind="attrs"
        v-on="on"
        @click="nuevaSolicitudDialog = true"
      >
        Nueva solicitud
      </v-btn>
    </template>
    <v-card color="primary">
      <v-card-title>Nueva solicitud</v-card-title>
      <v-card-text>
        <v-container>
          <v-form
            ref="form"
            v-model="solicitudForm"
          >
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="solicitud.oficio"
                  rounded
                  filled
                  dense
                  background-color="primary"
                  color="secondary"
                  label="Oficio"
                  :rules="required"
                />
                <v-text-field
                  v-model="solicitud.asunto"
                  rounded
                  filled
                  dense
                  background-color="primary"
                  color="secondary"
                  label="Asunto"
                  :rules="required"
                />
                <v-text-field
                  v-model="solicitud.descripcion"
                  rounded
                  filled
                  dense
                  background-color="primary"
                  color="secondary"
                  label="Descripción"
                />
                <v-text-field
                  v-model="solicitud.informacionExtra"
                  rounded
                  filled
                  dense
                  background-color="primary"
                  color="secondary"
                  label="Información extra"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          text
          color="secondary"
          class="px-4"
          @click="closeDialog()"
        >
          Cerrar
        </v-btn>
        <v-btn
          rounded
          color="secondary"
          class="px-4"
          :disabled="loading || !solicitudForm"
          @click="triggerGuardaSolicitud()"
        >
          Guardar solicitud
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      nuevaSolicitudDialog: false,
      solicitudForm: false,
      loading: false,
      solicitud: {
        oficio: '',
        asunto: '',
        descripcion: '',
        fk_idTipoSolicitud: null,
        informacionExtra: '',
      },

      required: [(v) => !!v || 'Este campo es requerido.'],
    };
  },

  computed: {
    ...mapGetters('tipoSolicitud', {
      tipoSolicitud: 'getTipoSolicitud',
    }),
  },

  methods: {
    ...mapActions('solicitudes', ['saveSolicitud', 'fetchSolicitudes']),

    closeDialog() {
      this.nuevaSolicitudDialog = false;
      this.solicitud = {
        oficio: '',
        asunto: '',
        descripcion: '',
        fk_idTipoSolicitud: null,
        informacionExtra: '',
      };
      this.$refs.form.resetValidation();
    },

    async triggerGuardaSolicitud() {
      this.loading = true;

      await this.saveSolicitud(this.solicitud);
      await this.fetchSolicitudes();

      this.loading = false;
      await this.closeDialog();
    },
  },
};
</script>
